import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ChevronRightSvg from 'images/v5/icons/chevron-right.svg';
import FolderOpenedSvg from 'images/v5/icons/folder-opened.svg';
import FolderSvg from 'images/v5/icons/folder.svg';
import Checkbox from 'layout/atoms/Checkbox/Checkbox';
import { selectIsFolderOpened, toggleIsFolderOpened } from 'store/specificationsFoldersSlice';
import { selectIsFolderOpenedMove, selectMoveFolder, setMoveFolder, toggleIsFolderOpenedMove, } from 'store/specificationsMoveSlice';
import styles from './FolderTreeButton.module.scss';
function FolderTreeButton({ node, children, isRoot, isLast, link, disabled = false, onClick, }) {
    const dispatch = useDispatch();
    const isFolderOpened = useSelector((state) => selectIsFolderOpened(state, node.id));
    const isFolderOpenedMove = useSelector((state) => selectIsFolderOpenedMove(state, node.id));
    const moveFolder = useSelector(selectMoveFolder);
    const folderLink = link || '/specifications/folders';
    if (onClick) {
        return (React.createElement("li", { className: classNames(styles.wrap, { [styles.opened]: isFolderOpenedMove }) },
            React.createElement("div", { className: styles.checkboxButton },
                React.createElement(Checkbox, { onClick: () => dispatch(setMoveFolder({ folderId: node.id })), value: moveFolder === node.id, disabled: disabled }),
                React.createElement("button", { type: "button", className: styles.button, onClick: () => {
                        onClick();
                        dispatch(toggleIsFolderOpenedMove({ id: node.id }));
                    } },
                    React.createElement("span", { className: styles.main },
                        React.createElement("span", { className: styles.icon }, isFolderOpenedMove && children ? React.createElement(FolderOpenedSvg, null) : React.createElement(FolderSvg, null)),
                        React.createElement("span", { className: styles.name }, node.name),
                        node.foldersCount > 0 && (React.createElement("span", { className: styles.counter },
                            "(",
                            node.foldersCount,
                            ")"))),
                    node.foldersCount > 0 && (React.createElement("span", { className: styles.chevron },
                        React.createElement(ChevronRightSvg, null))))),
            children));
    }
    return (React.createElement("li", { className: classNames(styles.wrap, {
            [styles.opened]: isFolderOpened,
            [styles.isRoot]: isRoot,
            [styles.isLast]: isLast,
        }) },
        React.createElement(NavLink, { to: `${folderLink}/${node.id}`, title: `${node.name} (${node.foldersCount})` },
            React.createElement("button", { type: "button", className: styles.button, onClick: () => {
                    dispatch(toggleIsFolderOpened({ id: node.id }));
                } },
                React.createElement("span", { className: styles.main },
                    React.createElement("span", { className: styles.icon }, isFolderOpened && children ? React.createElement(FolderOpenedSvg, null) : React.createElement(FolderSvg, null)),
                    React.createElement("span", { className: styles.name }, node.name),
                    node.foldersCount > 0 && React.createElement("span", { className: styles.counter },
                        "(",
                        node.foldersCount,
                        ")")),
                node.foldersCount > 0 && (React.createElement("span", { className: styles.chevron },
                    React.createElement(ChevronRightSvg, null))))),
        children));
}
export default FolderTreeButton;
